const comments = [
  {
    avatar: '匿',
    name: '吃瓜路人甲',
    time: '2小时前',
    content: '这个网站真的太方便了！以前到处找吃瓜视频，现在每天打开91吃瓜爆料网就能看到最新的爆料，高清播放还不卡顿，强烈推荐给所有瓜友！',
    tag: '忠实用户',
  },
  {
    avatar: '瓜',
    name: '资深吃瓜群众',
    time: '5小时前',
    content: '更新速度真的快，很多事件刚上热搜这里就有完整视频了。91吃瓜视频在线观看体验很好，比在其他平台刷视频效率高多了，已经安利给身边所有人。',
    tag: '活跃瓜友',
  },
  {
    avatar: '爆',
    name: '料事如神',
    time: '1天前',
    content: '作为一个吃瓜爱好者，91吃瓜爆料网是我见过资源最全的吃瓜平台。娱乐圈、网红圈、综艺圈的瓜都有，而且整理得很清晰，每天必刷！',
    tag: '新用户',
  },
];

const indexItems = [
  { label: '娱乐圈明星八卦', count: 1286, icon: 'ri-star-line' },
  { label: '社会热点事件追踪', count: 967, icon: 'ri-fire-line' },
  { label: '网红主播争议实录', count: 854, icon: 'ri-live-line' },
  { label: '综艺名场面回顾', count: 743, icon: 'ri-tv-line' },
  { label: '影视剧争议话题', count: 621, icon: 'ri-film-line' },
  { label: '品牌代言风波', count: 489, icon: 'ri-store-line' },
  { label: '音乐圈热门事件', count: 356, icon: 'ri-music-line' },
];

export default function CommentsIndexSection() {
  return (
    <>
      <section id="comments" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              瓜友热评
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              来看看其他吃瓜群众怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {comments.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-bold text-primary-600">{item.avatar}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                      <span className="inline-block px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                <div className="flex items-center gap-1 mt-2 text-accent-500">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="index" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              专题索引
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              按类别浏览吃瓜内容，快速找到你感兴趣的专题
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {indexItems.slice(0, 4).map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-lg text-primary-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">{item.label}</div>
                  <div className="text-xs text-foreground-400">{item.count} 条内容</div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
            {indexItems.slice(4).map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-3 p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-lg text-accent-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">{item.label}</div>
                  <div className="text-xs text-foreground-400">{item.count} 条内容</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}